"use client";

export function CheckoutFullPageLoader({ message }: { message?: string }) {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white/50 backdrop-blur-[2px]">
      <div className="flex flex-col items-center gap-4">
        <div className="flex gap-2">
          <div
            className="h-3 w-3 animate-pulse rounded-full bg-gray-400"
            style={{ animationDelay: "0ms" }}
          ></div>
          <div
            className="h-3 w-3 animate-pulse rounded-full bg-gray-400"
            style={{ animationDelay: "150ms" }}
          ></div>
          <div
            className="h-3 w-3 animate-pulse rounded-full bg-gray-400"
            style={{ animationDelay: "300ms" }}
          ></div>
        </div>

        {message && (
          <p className="text-base font-medium text-gray-700">{message}</p>
        )}
      </div>

      <style>{`body { pointer-events: none !important; }`}</style>
    </div>
  );
}
